import { prescryptiveHalfSteps, prescryptivePalette } from "./palette.js";
import { createTheme, rem } from "@myphx-engineering/phx-design-system/framework";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";

//#region src/index.ts
const theme = createTheme({
	primaryColor: "primary",
	primaryShade: {
		light: 7,
		dark: 2
	},
	colors: prescryptivePalette,
	radius: {
		xxs: "0.25rem",
		xs: "0.5rem",
		sm: "0.75rem",
		md: "1rem",
		lg: "1.25rem",
		xl: "1.5rem",
		xxl: "5rem"
	},
	defaultRadius: "sm",
	fontFamily: "Inter",
	headings: {
		fontFamily: "Poppins",
		fontWeight: "600",
		sizes: {
			h1: {
				fontSize: "1.5rem",
				lineHeight: "1.3"
			},
			h2: {
				fontSize: "1.25rem",
				lineHeight: "1.3"
			},
			h3: {
				fontSize: "1.125rem",
				lineHeight: "1.3"
			},
			h4: {
				fontSize: "1rem",
				lineHeight: "1.3"
			},
			h5: {
				fontSize: "0.875rem",
				lineHeight: "1.3"
			},
			h6: {
				fontSize: "0.75rem",
				lineHeight: "1.3"
			}
		}
	},
	fontSizes: {
		xs: "0.75rem",
		sm: "0.875rem",
		md: "1rem",
		lg: "1rem",
		xl: "1.125rem"
	},
	lineHeights: {
		xs: "1.5rem",
		sm: "1.5rem",
		md: "1.5rem",
		lg: "1.5rem",
		xl: "1.5rem"
	},
	spacing: {
		xxxs: "0.25rem",
		xxs: "0.5rem",
		xs: "0.75rem",
		sm: "1rem",
		md: "1.25rem",
		lg: "1.5rem",
		xl: "1.75rem",
		xxl: "2rem",
		xxxl: "2.5rem"
	},
	shadows: {
		xs: `${rem("1px")} ${rem("1px")} ${rem("6px")} rgba(27, 31, 50, 0.08)`,
		sm: `${rem("2px")} ${rem("2px")} ${rem("8px")} rgba(27, 31, 50, 0.08)`,
		md: `${rem("3px")} ${rem("3px")} ${rem("10px")} rgba(27, 31, 50, 0.08)`,
		lg: `${rem("4px")} ${rem("4px")} ${rem("12px")} rgba(27, 31, 50, 0.08)`,
		xl: `${rem("5px")} ${rem("5px")} ${rem("14px")} rgba(27, 31, 50, 0.08)`
	},
	focusRing: "never",
	other: { colors: { halfSteps: prescryptiveHalfSteps } }
});
var src_default = theme;

//#endregion
export { src_default as default };